export function buildTreeData(paths) {
  const root = [];

  // Clean, normalize, and dedupe (no need to enforce trailing slash here)
  const cleaned = Array.from(new Set(
    paths
      .filter(Boolean)
      .map(p => String(p)
        .replace(/\\/g, "/")        // backslashes -> slashes
        .replace(/^\.\//, "")       // remove leading "./"
        .replace(/\/+/g, "/")       // collapse multiple slashes
        .replace(/^\/+|\/+$/g, "")  // trim leading/trailing slashes
        .trim()
      )
      .filter(p => p.length > 0)
  ));

  cleaned.forEach(p => {
    const parts = p.split("/").filter(Boolean);
    let currentLevel = root;
    let parentPath = "";

    parts.forEach(part => {
      const currentPath = `${parentPath}${part}/`;

      let node = currentLevel.find(n => n.name === part);
      if (!node) {
        node = { name: part, path: currentPath, children: [] };
        currentLevel.push(node);
      }

      currentLevel = node.children;
      parentPath = node.path; 
    });
  });

  const sortDeep = (nodes) => {
    nodes.sort((a, b) => a.name.localeCompare(b.name));
    nodes.forEach(n => n.children?.length && sortDeep(n.children));
  };
  sortDeep(root);

  return root;
}
